import React from 'react';
import PropTypes from 'prop-types';
import Volume from './controls/Volume';
import PlaybackButton from './controls/PlaybackButton';
import ResetButton from './controls/ResetButton';
import ProgressBar from './controls/ProgressBar';
import { STYLES } from './AudioPlayerConstants';
import './AudioPlayer.scss';
import useAudioPlayer from './useAudioPlayer';

const { DEFAULT_BLUE_COLOR, DEFAULT_UNFILLED_PROGRES_COLOR, WHITE } = STYLES;

const AudioPlayer = ({
    audioSrc,
    classNameWrapper,
    progresBarFilledColor,
    progresBarUnfilledColor,
    volumeFilledColor,
    volumeUnfilledColor,
    audioLookerEvent,
}) => {
    const [
        audio,
        isPlaying,
        currentVolume,
        currentTime,
        duration,
        prevState,
        setVolume,
        onPause,
        onPlay,
        onSeek,
        onReset,
    ] = useAudioPlayer({
        audioSrc,
        progresBarFilledColor,
        progresBarUnfilledColor,
        volumeFilledColor,
        volumeUnfilledColor,
        audioLookerEvent,
    });

    if (!audioSrc) {
        return <div className={`audio ${classNameWrapper}`}>Loading...</div>;
    }

    return (
        <div className={`audio ${classNameWrapper}`}>
            <audio key={audioSrc} ref={audio}>
                <source src={audioSrc} type="audio/wav" />
                <track kind="captions" />
            </audio>
            <div className="controls">
                <Volume
                    currentVolume={currentVolume}
                    setVolume={setVolume}
                    filledColor={volumeFilledColor}
                    unfilledColor={volumeUnfilledColor}
                />
                <PlaybackButton isPlaying={isPlaying} onPause={onPause} onPlay={onPlay} />
                <ProgressBar
                    currentTime={currentTime}
                    duration={duration}
                    onSeek={onSeek}
                    filledColor={progresBarFilledColor}
                    unfilledColor={progresBarUnfilledColor}
                    onMouseUp={prevState ? onPlay : onPause}
                />
                <ResetButton onReset={onReset} />
            </div>
        </div>
    );
};

AudioPlayer.defaultProps = {
    audioSrc: '',
    progresBarFilledColor: DEFAULT_BLUE_COLOR,
    progresBarUnfilledColor: DEFAULT_UNFILLED_PROGRES_COLOR,
    volumeFilledColor: DEFAULT_BLUE_COLOR,
    volumeUnfilledColor: WHITE,
    classNameWrapper: '',
    audioLookerEvent: () => {},
};

AudioPlayer.propTypes = {
    audioSrc: PropTypes.string,
    progresBarFilledColor: PropTypes.string,
    progresBarUnfilledColor: PropTypes.string,
    volumeFilledColor: PropTypes.string,
    volumeUnfilledColor: PropTypes.string,
    classNameWrapper: PropTypes.string,
    audioLookerEvent: PropTypes.func,
};

export default AudioPlayer;
